import { useFormikContext } from 'formik'
import React from 'react'

import { SelectedCountries } from '@components/common/SelectedCountries'
import { SelectCountryModal } from '@components/modals/SelectCountryModal'
import { Subsection, useMediaQueryContext, useModalContext } from '@fourthwall/components'

import type { FormValues } from '../../ShippingGroup.types'

export const Countries = () => {
  const media = useMediaQueryContext()
  const { open } = useModalContext()
  const { values, setFieldValue, errors, submitCount } = useFormikContext<FormValues>()

  const openSelectCountryModal = () =>
    open(SelectCountryModal, {
      initialCountries: values.selectedCountries,
      title: 'Select countries to offer shipping to',
      onConfirm: (countries) => {
        setFieldValue('selectedCountries', countries)
      },
    })

  return (
    <Subsection title="Countries to offer shipping to" borderless noMargin>
      <div style={{ marginTop: -8 }}>
        <SelectedCountries
          maxHeight={media.laptop ? 400 : 290}
          data={values.selectedCountries}
          countriesCount={values.selectedCountries.length}
          error={submitCount ? errors.selectedCountries : undefined}
          onAddCountry={openSelectCountryModal}
          onRemoveCountry={(removedCountry) => {
            setFieldValue(
              'selectedCountries',
              values.selectedCountries.filter((country) => country !== removedCountry),
            )
          }}
        />
      </div>
    </Subsection>
  )
}
